import { Typography, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MobileModal from 'components/Shared/MobileModal';
import CloseIcon from '@material-ui/icons/Close';
import BackgroundBlurImage from 'components/Shared/BackgroundBlurImage';
import { IUpsell } from 'interface/upsell';
import { SyntheticEvent } from 'react';

import upsellFallbackImage from 'assets/img/nutror-card-upsell.png';
import useImageFallback from 'hooks/useImageFallback';

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: 'hidden',
    width: '100%',
    background: theme.palette.common.white,
    padding: theme.spacing(3),
    '@media(min-width: 501px)': {
      borderRadius: 8,
      padding: theme.spacing(6),
      maxWidth: 468,
      minWidth: 468,
      minHeight: 210,
    },
  },
  title: {
    '@media(max-width: 500px)': {
      display: 'none',
    },
    color: theme.palette.grey[600],
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
    fontWeight: 700,
  },
  section: {
    position: 'relative',
    display: 'flex',
  },
  imageContainer: {
    position: 'relative',
    margin: theme.spacing(4, 0),
    borderRadius: 8,
    overflow: 'hidden',
    width: '100%',
    maxWidth: 420,
    height: 290,
    '@media(max-width: 500px)': {
      height: 95,
      maxWidth: 144,
      overflow: 'hidden',
    },
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '& svg': {
      color: theme.palette.grey[600],
      fontSize: 32,
    },
    '& span': {
      fontWeight: 700,
      '@media(min-width: 425px)': {
        fontSize: 16,
      },
    },
  },
  contentContainer: {
    display: 'none',
    '@media(max-width: 500px)': {
      display: 'flex',
    },
    width: '100%',
    marginLeft: theme.spacing(2),
    flexDirection: 'column',
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 14,
      '@media(max-width: 425px)': {
        color: theme.palette.grey[600],
      },
      '&:last-of-type': {
        color: theme.palette.common.white,
        marginLeft: theme.spacing(2),
      },
    },
  },
  description: {
    color: theme.palette.grey[600],
    '@media(min-width: 425px)': {
      width: '100%',
      background: theme.palette.grey[100],
      padding: theme.spacing(4),
      fontSize: 16,
      marginBottom: theme.spacing(4),
    },
    padding: theme.spacing(3, 0),
  },
}));

interface IProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (event: SyntheticEvent) => void;
  upsell: IUpsell;
}

const Modal = (props: IProps) => {
  const imageProps = useImageFallback(props.upsell.small_image, upsellFallbackImage);
  const classes = useStyles();

  return (
    <MobileModal
      {...props}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          props.onClose();
        }
      }}
    >
      <div className={classes.container} id='upsell-modal'>
        <Typography variant='h4' className={classes.title} id='modal-upsell-title'>
          {props.upsell.title}
        </Typography>
        <div className={classes.section}>
          <div className={classes.imageContainer}>
            <BackgroundBlurImage {...imageProps} alt={props.upsell.title} />
          </div>
          <div className={classes.contentContainer}>
            <div className={classes.titleContainer}>
              <Typography variant='caption'>{props.upsell.title}</Typography>
              <CloseIcon onClick={props.onClose} />
            </div>
          </div>
        </div>
        <div className={classes.section}>
          <Typography variant='caption' className={classes.description}>
            {props.upsell.description}
          </Typography>
        </div>
        <div className={classes.actions}>
          <Button variant='text' color='primary' onClick={props.onClose} id='modal-upsell-btn-cancel'>
            Cancelar
          </Button>
          <Button variant='contained' color='primary' onClick={props.onConfirm} id='modal-upsell-btn-buy'>
            Compre agora
          </Button>
        </div>
      </div>
    </MobileModal>
  );
};

export default Modal;
